import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectAvailableCurrencies = createSelector(
  [selectConfigurationState],
  (state) => state.availableCurrencies
)
